import { t } from 'i18next';
import Swal from 'sweetalert2';
export const errorMessageWithHTML = (
  title: string,
  msg: string,
  callback?: (isConfirmed?: null) => void
) => {
  Swal.fire({
    icon: 'error',
    title: title,
    html: msg,
    confirmButtonText: 'OK',
    customClass: {
      confirmButton: 'btn btn-primary',
    },
  }).then(function (result) {
    if (result.isConfirmed) {
      if (callback) {
        callback(null);
      }
    }
  });
};
export const successMessageWithHTML = (
  title: string,
  msg: string,
  callback?: (isConfirmed?: null) => void
) => {
  Swal.fire({
    icon: 'success',
    title: title,
    html: msg,
    confirmButtonText: 'OK',
    customClass: {
      confirmButton: 'btn btn-primary',
    },
  }).then(function (result) {
    if (result.isConfirmed) {
      if (callback) {
        callback(null);
      }
    }
  });
};
export const largeSuccessMessageWithHTML = (
  title: string,
  msg: string,
  callback?: (isConfirmed?: null) => void
) => {
  Swal.fire({
    icon: 'success',
    title: title,
    html: msg,
    confirmButtonText: 'OK',
    width: '30%',
    customClass: {
      confirmButton: 'btn btn-primary',
    },
  }).then(function (result) {
    if (result.isConfirmed) {
      if (callback) {
        callback(null);
      }
    }
  });
};
export const confirmPaymentAlertWithFlag = (
  callback?: (isConfirmed?: boolean) => void,
  additionalDetails?: any
) => {
  Swal.fire({
    html: `
      <div class="empty-state-wrapper d-flex flex-column align-items-center justify-content-center text-center">
        <img src="/icons/icon_warning.svg" class="mb-2" alt="Warningicon" />
        <p class="mb-4">
        Please select payment transaction status
        </p>

        <div class="w-100 d-flex justify-content-between empty-state-footer">
          <button id="cancelBtn" class="btn btn-dark">
            ${additionalDetails?.cancelBtnText ?? t('fail')}
          </button>
          <button id="confirmBtn" class="btn btn-orange">
            ${additionalDetails?.confirmBtnText ?? t('success')}
          </button>
        </div>
      </div>
    `,
    customClass: {
      container: 'delete-confirm-container',
      popup: 'delete-confirm-popup',
      htmlContainer: 'delete-confirm-html-container',
    },
    showConfirmButton: false,
    showCancelButton: false,
    didOpen: () => {
      const confirmBtn = document.getElementById('confirmBtn');
      const cancelBtn = document.getElementById('cancelBtn');

      confirmBtn?.addEventListener('click', () => {
        Swal.close();
        callback?.(true);
      });

      cancelBtn?.addEventListener('click', () => {
        callback?.(false);
        Swal.close();
      });
    },
  });
};
// export const confirmAlert = (msg: string, callback?: (isConfirmed?: null) => void) => {
//   Swal.fire({
//     title: t('confirm_title'),
//     text: msg,
//     icon: 'warning',
//     showCancelButton: !0,
//     confirmButtonText: t('yes'),
//     cancelButtonText: t('no'),
//     customClass: {
//       confirmButton: 'btn btn-primary',
//       cancelButton: 'btn btn-secondary ms-3',
//     },
//     buttonsStyling: !1,
//   }).then(function (result) {
//     if (result.isConfirmed) {
//       if (callback) {
//         callback(null);
//       }
//     }
//   });
// };
export const confirmAlert = (
  title: string = t('confirm_title'),
  msg: string,
  callback?: (isConfirmed?: boolean) => void,
  additionalDetails?: any
) => {
  // const title = t('confirm_title');
  Swal.fire({
    html: `
      <div class="empty-state-wrapper d-flex flex-column align-items-center justify-content-center text-center">
        <img src="/icons/icon_warning.svg" class="mb-2" alt="Warningicon" />

        <h5 class="mb-2">${title ?? 'title'}</h5>

        <p class="mb-4">
        ${msg ?? 'Msg'}
        </p>

        <div class="w-100 d-flex justify-content-between empty-state-footer">
          <button id="cancelBtn" class="btn btn-dark">
            ${additionalDetails?.cancelBtnText ?? t('no_cancel_btn_text')}
          </button>
          <button id="confirmBtn" class="btn btn-orange">
            ${additionalDetails?.confirmBtnText ?? t('yes')}
          </button>
        </div>
      </div>
    `,
    customClass: {
      container: 'delete-confirm-container',
      popup: 'delete-confirm-popup',
      htmlContainer: 'delete-confirm-html-container',
    },
    showConfirmButton: false,
    showCancelButton: false,
    didOpen: () => {
      const confirmBtn = document.getElementById('confirmBtn');
      const cancelBtn = document.getElementById('cancelBtn');

      confirmBtn?.addEventListener('click', () => {
        Swal.close();
        callback?.(true);
      });

      cancelBtn?.addEventListener('click', () => {
        Swal.close();
      });
    },
  });
};
export const confirmSoldAlert = (
  title: string,
  msg: string,
  callback?: (isConfirmed?: boolean) => void,
  additionalDetails?: any
) => {
  Swal.fire({
    html: `
      <div class="empty-state-wrapper d-flex flex-column align-items-center justify-content-center text-center">
        <img src="/icons/icon-sold.svg" class="mb-2" alt="Deleteicon" />

        <h5 class="mb-2">${title ?? 'title'}</h5>

        <p class="mb-4">
        ${msg ?? 'Msg'}
        </p>

        <div class="w-100 d-flex justify-content-between empty-state-footer">
          <button id="cancelBtn" class="btn btn-dark">
            ${additionalDetails?.cancelBtnText ?? t('no_cancel_btn_text')}
          </button>
          <button id="confirmBtn" class="btn btn-orange">
            ${additionalDetails?.confirmBtnText ?? t('yes_confirm_delete_btn_text')}
          </button>
        </div>
      </div>
    `,
    // padding: 0,
    customClass: {
      container: 'delete-confirm-container',
      popup: 'delete-confirm-popup',
      htmlContainer: 'delete-confirm-html-container',
    },
    showConfirmButton: false,
    showCancelButton: false,
    didOpen: () => {
      const confirmBtn = document.getElementById('confirmBtn');
      const cancelBtn = document.getElementById('cancelBtn');

      confirmBtn?.addEventListener('click', () => {
        Swal.close();
        callback?.(true);
      });

      cancelBtn?.addEventListener('click', () => {
        Swal.close();
      });
    },
  });
};
export const confirmDeleteAlert = (
  title: string,
  msg: string,
  callback?: (isConfirmed?: boolean) => void,
  additionalDetails?: any
) => {
  Swal.fire({
    html: `
      <div class="empty-state-wrapper d-flex flex-column align-items-center justify-content-center text-center">
        <img src="/icons/icon-delete.svg" class="mb-2" alt="Deleteicon" />

        <h5 class="mb-2">${title ?? 'title'}</h5>

        <p class="mb-4">
        ${msg ?? 'Msg'}
        </p>

        <div class="w-100 d-flex justify-content-between empty-state-footer">
          <button id="cancelBtn" class="btn btn-dark">
            ${additionalDetails?.cancelBtnText ?? t('no_cancel_btn_text')}
          </button>
          <button id="confirmBtn" class="btn btn-orange">
            ${additionalDetails?.confirmBtnText ?? t('yes_confirm_delete_btn_text')}
          </button>
        </div>
      </div>
    `,
    // padding: 0,
    customClass: {
      container: 'delete-confirm-container',
      popup: 'delete-confirm-popup',
      htmlContainer: 'delete-confirm-html-container',
    },
    showConfirmButton: false,
    showCancelButton: false,
    didOpen: () => {
      const confirmBtn = document.getElementById('confirmBtn');
      const cancelBtn = document.getElementById('cancelBtn');

      confirmBtn?.addEventListener('click', () => {
        Swal.close();
        callback?.(true);
      });

      cancelBtn?.addEventListener('click', () => {
        Swal.close();
      });
    },
  });
};
export const confirmMesssageAlert = (msg: string, callback?: (isConfirmed?: boolean) => void) => {
  Swal.fire({
    // title: t('confirm_title'),
    text: msg,
    icon: 'warning',
    showCancelButton: !0,
    confirmButtonText: t('yes'),
    cancelButtonText: t('no'),
    customClass: {
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn btn-secondary ms-3',
    },
    buttonsStyling: !1,
  }).then(function (result) {
    if (callback) {
      callback(result.isConfirmed);
    }
    // if (result.isConfirmed) {
    //   if (callback) {
    //     callback(null);
    //   }
    // }
  });
};

export const comingSoonAlert = (msg?: string, callback?: () => void) => {
  Swal.fire({
    html: `
      <div class="empty-state-wrapper d-flex flex-column align-items-center justify-content-center text-center py-4">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ff5a00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="mb-3">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </svg>

        <h5 class="mb-2" style="font-family: inherit; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px;">
          ${t('stay_tuned', 'Stay tuned!')}
        </h5>

        <p class="mb-4 text-muted" style="font-size: 13.5px; line-height: 1.5; max-width: 280px; margin: 0 auto;">
          ${msg || t('coming_soon_desc', 'This feature is launching soon')}
        </p>

        <div class="w-100 d-flex justify-content-center empty-state-footer">
          <button id="okBtn" class="btn btn-orange px-5" style="font-weight: 700; min-width: 120px;">
            ${t('ok', 'OK')}
          </button>
        </div>
      </div>
    `,
    customClass: {
      container: 'delete-confirm-container',
      popup: 'delete-confirm-popup coming-soon-popup',
      htmlContainer: 'delete-confirm-html-container',
    },
    showConfirmButton: false,
    showCancelButton: false,
    didOpen: () => {
      const okBtn = document.getElementById('okBtn');
      okBtn?.addEventListener('click', () => {
        Swal.close();
        if (callback) callback();
      });
    },
  });
};
